<template>
    <div v-loading="loading" class="custom-service-params">
        <div class="deploy-service-box">
            <h1>HTTP 配置</h1>

            <hc-form
                key="tableFormObj"
                ref="tableFormObj"
                size="mini"
                label-position="left"
                label-width="0"
                :model="tableFormObj"
                :rules="rulesObj"
                @validate="onTableFormObjValidateFunc"
            >
                <hc-table
                    key="table_headers"
                    :data="tableFormObj.tableDataArr"
                    :row-class-name="
                        ({ row, rowIndex }) => {
                            row.index = rowIndex
                            return errorRowIndex.includes(rowIndex)?'has_error':''
                        }
                    "
                    @row-click="row => $set(varObj, 'activeRowIndex', row.index)"
                >
                    <hc-table-column label="名称" width="302">
                        <template slot-scope="{ $index, row }">
                            <hc-form-item
                                :prop="'tableDataArr.' + $index + '.key'"
                                :rules="rulesObj.key"
                            >
                                <hc-input v-model="row.key" class="key-input" type="text" placeholder="请输入名称"
                                    :disabled="getFormItemDisabelStatus(row)"
                                >
                                    <template v-if="isTenantApp && row.addField" :slot="row.customizeType === 0 ? 'prepend' : 'append'">
                                        {{ row.customizeField }}
                                    </template>
                                </hc-input>
                            </hc-form-item>
                        </template>
                    </hc-table-column>
                    <hc-table-column label="位置" width="160">
                        <template slot-scope="{ $index, row }">
                            <hc-form-item
                                v-if="row.paramType === 'path'"
                                :prop="'tableDataArr.' + $index + '.sourceType'"
                                :rules="rulesObj.paramType"
                            >
                                <hc-select
                                    :value="row.paramType"
                                    disabled
                                >
                                    <hc-option key="path" disabled label="path" value="path" />
                                </hc-select>
                            </hc-form-item>
                            <hc-form-item
                                v-else
                                :prop="'tableDataArr.' + $index + '.sourceType'"
                                :rules="rulesObj.paramType"
                            >
                                <hc-select
                                    :value="row.paramType"
                                    :disabled="row.paramType === 'path' || getFormItemDisabelStatus(row)"
                                    @change="(v) => {
                                        row.paramType = v
                                        if (v === 'headers') {
                                            row.type = 'string'
                                        }
                                    }"
                                >
                                    <hc-option key="Query" label="Query" value="Query" />
                                    <hc-option key="headers" label="Header" value="headers" />
                                </hc-select>
                            </hc-form-item>
                        </template>
                    </hc-table-column>
                    <hc-table-column
                        label="数据类型"
                        width="160"
                    >
                        <template slot-scope="{ $index, row }">
                            <hc-form-item
                                :prop="'tableDataArr.' + $index + '.type'"
                            >
                                <hc-select v-if="row.paramType === 'headers'" v-model="row.type" :disabled="isTenantApp ? !row.isTenant : false" @hook:created="() => row.type = 'string'">
                                    <hc-option key="string" label="String" value="string" />
                                </hc-select>
                                <hc-select
                                    v-else
                                    v-model="row.type"
                                    placeholder="请选择值类型" :disabled="getFormItemDisabelStatus(row)"
                                >
                                    <hc-option key="string" label="String" value="string" />
                                    <hc-option key="number" label="Number" value="number" />
                                    <hc-option key="object" label="Object" value="object" />
                                    <hc-option key="stringArray" label="StringArray" value="stringArray" />
                                    <hc-option key="numberArray" label="NumberArray" value="numberArray" />
                                    <hc-option key="Boolean" label="Boolean" value="boolean" />
                                </hc-select>
                            </hc-form-item>
                        </template>
                    </hc-table-column>

                    <hc-table-column label="动态传入" width="120">
                        <template slot-scope="{ $index, row }">
                            <hc-form-item
                                :prop="'tableDataArr.' + $index + '.sourceType'"
                                :rules="rulesObj.sourceType"
                            >
                                <hc-select
                                    :value="row.sourceType"
                                    size="mini"
                                    :disabled="getFormItemDisabelStatus(row)"
                                    @change="(v) => {
                                        row.sourceType = v
                                        if (v === 'dynamic') {
                                            row.value = ''
                                        }
                                    }"
                                >
                                    <hc-option key="dynamic" label="是" value="dynamic" />
                                    <hc-option key="fixed" label="否" value="fixed" />
                                </hc-select>
                            </hc-form-item>
                        </template>
                    </hc-table-column>
                    <hc-table-column label="" width="220">
                        <template slot-scope="{ $index, row }">
                            <hc-form-item
                                :key="row.sourceType"
                                :prop="row.sourceType !== 'dynamic' ? 'tableDataArr.' + $index + '.value' : ''"
                                :rules="rulesObj.value"
                            >
                                <template v-if="row.type === 'boolean'">
                                    <hc-select
                                        v-if="row.sourceType === 'dynamic'"
                                        value=""
                                        disabled
                                        placeholder="请选择"
                                    >
                                        <hc-option key="false" label="false" :value="false" />
                                        <hc-option key="true" label="true" :value="true" />
                                    </hc-select>
                                    <hc-select
                                        v-else
                                        v-model="row.value"
                                        :disabled="getFormItemDisabelStatus(row)"
                                        placeholder="请选择"
                                    >
                                        <hc-option key="false" label="false" :value="false" />
                                        <hc-option key="true" label="true" :value="true" />
                                    </hc-select>
                                </template>
                                <template v-else>
                                    <hc-input
                                        v-if="row.sourceType === 'dynamic'"
                                        value=""
                                        disabled
                                        type="text"
                                        placeholder="根据外部传入"
                                    />
                                    <hc-input
                                        v-else
                                        v-model="row.value"
                                        :disabled="getFormItemDisabelStatus(row)"
                                        type="text"
                                        placeholder="请输入Value"
                                    />
                                </template>
                            </hc-form-item>
                        </template>
                    </hc-table-column>
                    <hc-table-column
                        label="必填"
                        width="216"
                    >
                        <template slot-scope="{ $index, row }">
                            <hc-form-item
                                :prop="'tableDataArr.' + $index + '.required'"
                                :rules="rulesObj.required"
                            >
                                <hc-radio-group v-model="row.required" :disabled="row.paramType === 'path' || isTenantApp ? !row.isTenant : false" placeholder="请选择是否必填">
                                    <hc-radio key="true" :label="true">
                                        是
                                    </hc-radio>
                                    <hc-radio key="false" :label="false">
                                        否
                                    </hc-radio>
                                </hc-radio-group>
                            </hc-form-item>
                        </template>
                    </hc-table-column>
                    <hc-table-column label="操作" min-width="132">
                        <template slot-scope="{ $index, row }">
                            <hc-button v-if="row && row.paramType !== 'path'" type="text" :disabled="isTenantApp ? !row.isTenant : false" @click="delParamFn(tableFormObj.tableDataArr, $index)">
                                删除
                            </hc-button>
                            <hc-button
                                v-if="varObj.hoverRowIndex === $index"
                                :disabled="isTenantApp ? !row.isTenant : false"
                                type="text"
                                @click="row => $set(varObj, 'activeRowIndex', $index)"
                            >
                                编辑
                            </hc-button>
                        </template>
                    </hc-table-column>
                </hc-table>
            </hc-form>
            <div
                v-if="isTenantApp ? validPurviewService.updateService : true"
                class="params-config-dialog__add-btn"
                @click="addParamFn('tableFormObj', tableFormObj.tableDataArr)"
            >
                <span style="font-size: 16px;margin-right:4px;" class="hc-icon-circle-plus-outline" />
                <span>新增</span>
            </div>

            <template v-if="showBody">
                <hc-form-item
                    label="请求 Body"
                >
                    <hc-radio-group
                        v-model.trim="apiParamObj.body.contentType"
                        placeholder="请选择请求体"
                        size="mini"
                        :disabled="(isTenantApp && !apiParamObj.isTenant)"
                        @change="changeRequestBodyFn"
                    >
                        <hc-radio key="postData" label="postData">
                            业务对象
                        </hc-radio>
                        <hc-radio key="form-data" label="multipart/form-data">
                            form-data
                        </hc-radio>
                        <hc-radio key="form-urlencode" label="application/x-www-form-urlencoded">
                            x-www-form-urlencoded
                        </hc-radio>
                        <hc-radio key="octet-stream" label="application/octet-stream">
                            binary
                        </hc-radio>
                        <hc-radio key="json" label="application/json">
                            Raw-Json
                        </hc-radio>
                    </hc-radio-group>
                </hc-form-item>
                <hc-form
                    v-if="showBody && contentType === 'postData'"
                    ref="postForm"
                    key="responseForm"
                    label-width="112px"
                    :model="apiParamObj.body.object"
                >
                    <div class="row">
                        <hc-form-item
                            :key="apiParamObj.body.object.objectId + contentType"
                            style="margin-bottom: 12px"
                            label="业务对象"
                            prop="objectId"
                            :rules="[{ required: true, message: '请选择业务对象', trigger: ['blur'] }]"
                        >
                            <object-picker
                                v-model="apiParamObj.body.object.objectId"
                                :object-name.sync="varObj.objectName"
                                :business-env-id="businessEnvId"
                                :disabled="(isTenantApp && !apiParamObj.isTenant)"
                            />
                        </hc-form-item>
                    </div>
                </hc-form>
                <div v-else-if="contentType === 'application/octet-stream'" class="binary-tip">
                    <i class="hc-icon hc-icon-info">i</i>请求主体（Body）是一段二进制流
                </div>

                <hc-form
                    v-else
                    key="tableFormRequestObj"
                    ref="tableFormRequestObj"
                    label-position="left"
                    label-width="0"
                    :model="tableFormRequestObj"
                    :rules="rulesObj"
                    @validate="onTableFormObjValidateFunc"
                >
                    <hc-table
                        :data="tableFormRequestObj.tableData"
                        :row-class-name="
                            ({ row, rowIndex }) => {
                                row.index = rowIndex
                                return errorRowIndex.includes(rowIndex)?'has_error':''
                            }
                        "
                        @row-click="row => $set(varObj, 'activeRowIndex', row.index)"
                    >
                        <hc-table-column label="名称">
                            <template slot-scope="{ $index, row }">
                                <hc-form-item
                                    :prop="'tableData.' + $index + '.key'"
                                    :rules="rulesObj.key"
                                >
                                    <hc-input v-model="row.key" class="key-input" type="text" placeholder="请输入名称" size="mini"
                                        :disabled="isTenantApp ? !row.isTenant : false"
                                    >
                                        <template v-if="isTenantApp && row.addField" :slot="row.customizeType === 0 ? 'prepend' : 'append'">
                                            {{ row.customizeField }}
                                        </template>
                                    </hc-input>
                                </hc-form-item>
                            </template>
                        </hc-table-column>
                        <hc-table-column
                            label="数据类型"
                        >
                            <template slot-scope="{ $index, row }">
                                <hc-form-item
                                    :prop="'tableData.' + $index + '.type'"
                                >
                                    <hc-select v-model="row.type" placeholder="请选择值类型" size="mini"
                                        :disabled="isTenantApp ? !row.isTenant : false"
                                    >
                                        <hc-option key="string" label="String" value="string" />
                                        <hc-option key="number" label="Number" value="number" />
                                        <hc-option key="object" label="Object" value="object" />
                                        <hc-option key="objectArray" label="ObjectArray" value="objectArray" />
                                        <hc-option key="stringArray" label="StringArray" value="stringArray" />
                                        <hc-option key="numberArray" label="NumberArray" value="numberArray" />
                                        <hc-option key="Boolean" label="Boolean" value="boolean" />
                                    </hc-select>
                                </hc-form-item>
                            </template>
                        </hc-table-column>
                        <hc-table-column
                            label="必填"
                        >
                            <template slot-scope="{ $index, row }">
                                <hc-form-item
                                    :prop="'tableData.' + $index + '.required'"
                                    :rules="rulesObj.required"
                                >
                                    <hc-radio-group v-model="row.required" placeholder="请选择是否必填" size="mini"
                                        :disabled="isTenantApp ? !row.isTenant : false"
                                    >
                                        <hc-radio key="true" :label="true">
                                            是
                                        </hc-radio>
                                        <hc-radio key="false" :label="false">
                                            否
                                        </hc-radio>
                                    </hc-radio-group>
                                </hc-form-item>
                            </template>
                        </hc-table-column>

                        <hc-table-column label="操作">
                            <template slot-scope="{ $index, row }">
                                <hc-button type="text"
                                    :disabled="isTenantApp ? !row.isTenant : false"
                                    @click="delParamFn(tableFormRequestObj.tableData, $index)"
                                >
                                    删除
                                </hc-button>
                                <hc-button
                                    v-if="varObj.hoverRowIndex === $index"
                                    type="text"
                                    :disabled="isTenantApp ? !row.isTenant : false"
                                    @click="row => $set(varObj, 'activeRowIndex', $index)"
                                >
                                    编辑
                                </hc-button>
                            </template>
                        </hc-table-column>
                    </hc-table>
                </hc-form>
                <div
                    v-if="showParamsAddBtn"
                    class="params-config-dialog__add-btn"
                    @click="addParamFn('tableFormRequestObj', tableFormRequestObj.tableData)"
                >
                    <span style="font-size: 16px;margin-right:4px;" class="hc-icon-circle-plus-outline" />
                    <span>新增</span>
                </div>
            </template>
        </div>

        <div class="deploy-service-box response-form">
            <h1>
                返回值
            </h1>
            <hc-form ref="responseForm" key="responseForm" label-width="112px" :class="{'collapse': responseCollapse}" :model="apiParamObj.response">
                <div class="row">
                    <hc-form-item
                        label="返回类型"
                        prop="dataType"
                        :rules="[{ required: true, message: '请选择数据返回类型', trigger: ['blur', 'change'] }]"
                    >
                        <hc-select v-model.trim="apiParamObj.response.dataType" placeholder="请选择返回类型" size="mini"
                            :disabled="(isTenantApp && !apiParamObj.isTenant)"
                        >
                            <hc-option key="string" label="String" value="string" />
                            <hc-option key="number" label="Number" value="number" />
                            <hc-option key="boolean" label="Boolean" value="boolean" />
                            <hc-option key="object" label="Object" value="object" />
                            <hc-option key="objectArray" label="ObjectArray" value="objectArray" />
                            <hc-option key="stringArray" label="StringArray" value="stringArray" />
                            <hc-option key="numberArray" label="NumberArray" value="numberArray" />
                        </hc-select>
                    </hc-form-item>
                    <hc-form-item
                        v-if="apiParamObj.response.dataType === 'object' || apiParamObj.response.dataType === 'objectArray'"
                        :key="apiParamObj.response.objectId"
                        label="业务对象"
                        prop="objectId"
                        :rules="[{ required: true, message: '请选择业务对象', trigger: ['blur'] }]"
                    >
                        <object-picker
                            v-model="apiParamObj.response.objectId"
                            :object-name.sync="apiParamObj.response.objectName"
                            :business-env-id="businessEnvId"
                            :disabled="(isTenantApp && !apiParamObj.isTenant)"
                        />
                    </hc-form-item>
                </div>
                <div class="row">
                    <hc-form-item
                        label="判断依据字段"
                        prop="codeName"
                        :rules="[{ required: true, message: '请填写判断依据字段', trigger: ['blur', 'change'] }, nestLimit]"
                    >
                        <hc-input
                            v-model.trim="apiParamObj.response.codeName"
                            type="text"
                            :disabled="(isTenantApp && !apiParamObj.isTenant)"
                            placeholder="请输入判断依据字段"
                            size="mini"
                        />
                    </hc-form-item>
                    <hc-form-item
                        label="成功值"
                        prop="successCodeValue"
                        :rules="[{ required: true, message: '请填写成功值', trigger: ['blur', 'change'] }]"
                    >
                        <hc-input
                            v-model.trim="apiParamObj.response.successCodeValue"
                            type="text"
                            :disabled="(isTenantApp && !apiParamObj.isTenant)"
                            placeholder="请输入成功值"
                            size="mini"
                        />
                    </hc-form-item>
                </div>

                <div class="row">
                    <hc-form-item
                        label="错误消息字段"
                        prop="msgName"
                        :rules="[{ required: true, message: '请填写错误消息字段', trigger: ['blur', 'change'] }, nestLimit]"
                    >
                        <hc-input
                            v-model.trim="apiParamObj.response.msgName"
                            type="text"
                            :disabled="(isTenantApp && !apiParamObj.isTenant)"
                            placeholder="请输入错误消息字段"
                            size="mini"
                        />
                    </hc-form-item>
                    <hc-form-item
                        label="数据内容字段"
                        prop="dataName"
                        :rules="[{ required: true, message: '请填写数据内容字段', trigger: ['blur', 'change'] }, nestLimit ]"
                    >
                        <hc-input
                            v-model.trim="apiParamObj.response.dataName"
                            type="text"
                            :disabled="(isTenantApp && !apiParamObj.isTenant)"
                            placeholder="请输入数据内容字段"
                            size="mini"
                        />
                    </hc-form-item>
                </div>
                <div class="row">
                    <hc-form-item
                        v-if="apiParamObj.response.dataType === 'objectArray'"
                        prop="totalName"
                    >
                        <template slot="label">
                            <span>
                                总条数字段
                                <hc-tooltip class="item" effect="dark" content="该字段需要配合列表组件的是否显示总条数来控制" placement="top">
                                    <i class="hc-icon-question" style="margin-left: 2px;font-size: 14px;position: relative;top:1px" />
                                </hc-tooltip>
                            </span>
                        </template>
                        <hc-input
                            v-model.trim="apiParamObj.response.totalName"
                            type="text"
                            :disabled="(isTenantApp && !apiParamObj.isTenant)"
                            placeholder="请输入总条数字段"
                            size="mini"
                        />
                    </hc-form-item>
                </div>
            </hc-form>

            <h4 class="expand-btn" :class="{'collapse': responseCollapse}" @click="responseCollapse = !responseCollapse">
                高级解析规则
                <i class="el-icon-arrow-down" />
            </h4>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapState } from 'vuex'
import * as T from '@common/store/app-resource/types'
import { APP_RESOURCE, STAR_MAP, WORKSPACE } from '@common/store/module-types'
import { GET_MIP_API_LIST } from '@common/store/star-map/types'
import { getFormsValidRes } from '@common/utils/formValidToPromise'
import paramMixin from '../mixins/param'
import ObjectPicker from '../object/object-picker'

export default {
    name: 'CustomServiceParams',
    components: {
        ObjectPicker,
    },
    mixins: [paramMixin],
    props: {
        varObj: {
            type: Object,
            require: true,
        },
        apiParamObj: {
            type: Object,
            require: true,
        },
        rulesObj: {
            type: Object,
            require: true,
        },
        isNotXingTuApi: {
            type: Boolean,
        },
        businessEnvId: {
            type: String,
        },
    },
    data() {
        return {
            // 请求接口的参数
            tableFormObj: {
                tableDataArr: [],
            },
            tableFormHeadersObj: {
                tableDataArr: [],
            },
            tableFormRequestObj: {
                tableData: [],
            },
            errorRowIndex: [],
            loading: false,
            mockDataRules: [
                { required: true, message: 'mock数据不能为空', trigger: ['blur'] },
            ],
            nestLimit: {
                validator: (rule, value, callback) => {
                    const list = value.split('.')
                    if (list.length > 5) {
                        callback('数据嵌套不能超过5层')
                    }
                    callback()
                },
                trigger: ['blur'],
            },
        }
    },
    computed: {
        ...mapState(WORKSPACE, ['current']),
        appInfo() {
            return this.$store.state.modeling.app
        },
        xingTuEnvId() {
            return (this.current.xingtuInfo || {}).xingTuEnvId || ''
        },
        xingtuEnable() {
            // 是否开启集成开放平台且分支绑定了集成开放平台
            return this.appInfo.xingtuEnable && this.xingTuEnvId
        },
        showBody() {
            const methods = ['post', 'put', 'delete']
            const { method } = this.apiParamObj
            return methods.includes(method)
        },
        showParamsAddBtn() {
            const {
                showBody, isTenantApp, validPurviewService, contentType,
            } = this

            const cTypes = ['multipart/form-data', 'application/x-www-form-urlencoded', 'application/json']

            const add = showBody && cTypes.includes(contentType)
            
            return add && (isTenantApp ? validPurviewService.updateService : true)
        },
        contentType() {
            return this.apiParamObj.body.contentType
        },
    },
    watch: {
        tableFormObj: {
            deep: true,
            handler(val) {
                const querys = val.tableDataArr.filter(item => item.paramType === 'Query').map(item => {
                    const { paramType, ...other } = item
                    return other
                })
                const headers = val.tableDataArr.filter(item => item.paramType === 'headers').map(item => {
                    const { paramType, ...other } = item
                    return other
                })
                const requestMetadata = this.tableFormRequestObj.tableData.map(item => {
                    const { paramType, ...other } = item
                    return other
                })
                this.$emit('change-api-param', {
                    querys,
                    headers,
                    requestMetadata,
                })
                this.$emit('change-temp-param', val.tableDataArr)
            },
        },
        tableFormRequestObj: {
            deep: true,
            handler(val) {
                const requestMetadata = val.tableData.map(item => {
                    const { paramType, ...other } = item
                    return other
                })
                const querys = this.tableFormObj.tableDataArr.filter(item => item.paramType === 'Query').map(item => {
                    const { paramType, ...other } = item
                    return other
                })
                const headers = this.tableFormObj.tableDataArr.filter(item => item.paramType === 'headers').map(item => {
                    const { paramType, ...other } = item
                    return other
                })
                this.$emit('change-api-param', {
                    querys,
                    headers,
                    requestMetadata,
                })
                this.$emit('change-temp-body', val.tableData)
            },

        },

    },
    mounted() {
        // this.$emit('load-starMap-start')
        // if (this.xingtuEnable) {
        //     this.getMipApiList({
        //         xingTuEnvId: this.xingTuEnvId,
        //     }).finally(() => {
        //         this.$emit('load-starMap-end')
        //     })
        // } else {
        //     this.$emit('load-starMap-end')
        // }

        this.compatibleHandle()
        const headers = this.apiParamObj.headers.map(item => ({
            ...item,
            paramType: 'headers',
        }))
        const querys = this.apiParamObj.querys.map(item => ({
            ...item,
            paramType: 'Query',
        }))
        this.tableFormObj.tableDataArr = [...this.tableFormObj.tableDataArr, ...headers, ...querys]
        this.tableFormRequestObj.tableData = this.apiParamObj?.body?.params ?? []
    },
    methods: {
        ...mapActions(STAR_MAP, {
            getMipApiList: GET_MIP_API_LIST,
        }),
        ...mapActions(APP_RESOURCE, {
            getObject: T.GET_NEW_OBJECT,
            getObjectDtl: T.GET_NEW_OBJECT_DTL,
        }),

        // 兼容旧的contentType（formData/postData）数据
        compatibleHandle() {
            if (this.contentType || !this.varObj) {
                return
            }
            const { requestBody } = this.varObj
            // 映射旧 contentType（formData/postData） 为新的结构
            if (requestBody === 'formData') {
                this.$set(this.apiParamObj.body, 'contentType', 'application/json')
            }
            if (requestBody === 'postData') {
                this.$set(this.apiParamObj.body, 'contentType', 'postData')
            }
        },
        // 删除参数
        delParamFn(arr, index) {
            arr.splice(index, 1)
        },
        async validate(cb) {
            const valid = await getFormsValidRes(this.$refs.responseForm, this.$refs.postForm, this.$refs.tableFormObj, this.$refs.tableFormRequestObj)
            cb && cb(valid)
        },
        resetFields() {
            this.$refs.responseForm.resetFields()
            this.tableFormObj.tableDataArr = []
            this.tableFormRequestObj.tableData = []
            this.apiParamObj.contentType = 'application/json'
        },
        // 增加参数
        addParamFn(tabRef, arr) {
            this.$refs[tabRef].validate(valid => {
                const params = {
                    key: '',
                    sourceType: 'dynamic',
                    type: 'string',
                    required: true,
                    paramType: 'Query',
                }
                if (this.isTenantApp) {
                    params.isTenant = true
                    const { addField, customizeField, customizeType } = this.validPurviewObject

                    if (addField && !this.apiParamObj.isTenant) {
                        params.addField = addField
                        params.customizeField = customizeField
                        params.customizeType = customizeType
                    }
                }
                if (valid) {
                    arr.push(params)
                    this.$set(this.varObj, 'activeRowIndex', arr.length - 1)
                }
            })
        },
        getTableDataFn() {
            if (this.apiParamObj.method === 'post' && this.varObj.paramType === 'request') {
                if (!this.apiParamObj.body) {
                    this.apiParamObj.body = {}
                }
                if (this.contentType === 'formData') {
                    this.apiParamObj.body.object = {
                        objectId: '',
                    }
                }
                // this.$set(this.tableFormObj, 'tableDataArr', this.apiParamObj.body.params)

                return this.apiParamObj.body.params || []
            }

            // this.$set(this.tableFormObj, 'tableDataArr', this.apiParamObj[this.varObj.paramType])
            return this.apiParamObj[this.varObj.paramType]
        },
        async getObjectDtlFn(obj, id) {
            if (!id) {
                return
            }
            try {
                const resData = await this.getObjectDtl({
                    objectId: id,
                })
                this.$set(obj, 'objectName', resData.title)
            } catch (error) {
                // this.$message.error(error.message)
            }
        },
        // 改变请求体请求方式
        changeRequestBodyFn(val) {
            this.apiParamObj.body = this.apiParamObj.body || {}
            if (val !== 'postData' && val !== 'application/octet-stream') {
                this.$set(this.apiParamObj.body, 'type', 'params')
                if (!this.apiParamObj.body.params) {
                    this.apiParamObj.body.params = []
                }
            }
            if (val === 'postData') {
                this.$set(this.apiParamObj.body, 'type', 'object')
                if (!this.apiParamObj.body.object || !this.apiParamObj.body.object.objectId) {
                    this.$set(this.apiParamObj.body, 'object', {})
                }
            }
        },

        onTableFormObjValidateFunc(option, status) {
            const index = option && option.indexOf('.') + 1
            const errorRowIndex = [...this.errorRowIndex]
            const rowIndex = parseInt(option.slice(index, index + 1), 10)
            if (!status) {
                errorRowIndex.push(rowIndex)
            } else {
                _.remove(errorRowIndex, item => item === rowIndex)
            }
            this.errorRowIndex = [...errorRowIndex]
        },

        getFormItemDisabelStatus(row) {
            return row?.paramType === 'path' || this.isTenantApp ? !row.isTenant : false
        },

        getPathParam(pathVar) {
            this.tableFormObj.tableDataArr = this.tableFormObj.tableDataArr.filter(item => item.paramType !== 'path')
            if (pathVar) {
                const pathParams = this.tableFormObj.tableDataArr
                    .filter(item => item.paramType === 'path')
                    .filter(item => pathVar.includes(item.key))
                    .map(item => item.key)
                const res = _.uniq([...pathParams, ...pathVar])
                    .map(item => ({
                        key: item,
                        value: '--',
                        sourceType: 'dynamic',
                        type: 'string',
                        required: true,
                        paramType: 'path',

                    }))
                this.tableFormObj.tableDataArr = [...res, ...this.tableFormObj.tableDataArr]
            }
        },

    },
}
</script>

<style lang="less" scoped>
@deep: ~'>>>';
@import url('./common.less');
.custom-title{
    color: #222222;
    font-size: 16px;
    font-weight: 400;
    margin: 32px 0 16px;
}
.params-config-dialog {
    &__add-btn {
        display: inline-flex;
        align-items: center;
        height: 28px;
        text-align: center;
        border-radius: 3px;
        margin-top: 12px;
        color: #2a6aff;
        font-size: 12px;
        cursor: pointer;
        padding: 0 8px;
        border: 0 solid rgba(80,122,254,1);
        background-color: white;
        transition: background-color .3s;

        &:hover {
            background-color: rgba(245,245,245,1);
        }

        & + .hc-form-item {
            margin-top: 8px;
            margin-bottom: 0;
        }
    }
}
.param-type__wraper {
    .param-type__item {
        display: inline-block;
        cursor: pointer;
        margin-right: 26px;
        &__icon {
            display: inline-block;
            position: relative;
            border: 2px solid #d3d8e9;
            border-radius: 100%;
            width: 16px;
            height: 16px;
            background-color: #fff;
            cursor: pointer;
            margin-right: 12px;
            box-sizing: border-box;
        }
        &__icon--active {
            border-color: #4c99fe;
        }
        &__icon--active::after {
            content: '';
            width: 6px;
            height: 6px;
            border-radius: 100%;
            background-color: #4c99fe;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
        > span {
            vertical-align: middle;
        }
    }
}
.custom-service-params {
    @{deep} .object-picker__body {
    }
    .hc-input{
        display: inline-block;
        &.key-input {
            display: inline-table;
        }
    }
    @{deep} .hc-input--mini .hc-input__inner{
        height: 32px;
        display: block;
    }
    @{deep} .hc-table .hc-form-item{
        margin: 0;
    }
    @{deep} .hc-table .hc-table__row.has_error{
        .hc-form-item{
            margin: 15px 0 20px;
        }
    }
    @{deep} .hc-form-item__error{
        padding-top: 0;
        line-height: 17px;
    }

    /deep/ .hc-table {
        th.hc-table__cell.is-leaf {
            border-color: #EAEAEA;
            padding: 8px 0;
            font-size: 13px;
            font-weight: 400;
            background: #FBFBFB;
        }

        .hc-table td.hc-table__cell {
            border-color: #EAEAEA;
        }

        .hc-input__suffix {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .hc-select {
            width: 100%;
        }
    }

    /deep/ .hc-form-item__content > .object-picker {
        margin-top: 4px;

        .object-picker__body {
            font-size: 12px;
            padding-left: 8px;
            color: #222;
        }
    }
}
.new-object .custom-service-params{
    @{deep} .hc-table .hc-form-item{
        margin: 0;
    }
}
.binary-tip {
    height: 34px;
    line-height: 34px;
    background: rgba(38, 110, 255, 0.1);
    font-size: 12px;
    color: #666;
    padding: 0 14px;
    border-radius: 3px;

    .hc-icon-info {
        &::before {
            display: none;
        }

        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: #266EFF;
        width: 14px;
        height: 14px;
        border-radius: 100%;
        color: white;
        text-align: center;
        margin-right: 8px;
    }
}
</style>
